var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7148 3.85938H2.28516C1.02258 3.85938 0 4.8883 0 6.14453V19.8555C0 21.1192 1.0301 22.1406 2.28516 22.1406H23.7148C24.9669 22.1406 26 21.1235 26 19.8555V6.14453C26 4.89054 24.9815 3.85938 23.7148 3.85938ZM23.3948 5.38281C22.9279 5.84721 14.8933 13.8396 14.6159 14.1155C14.1842 14.5472 13.6104 14.7848 13 14.7848C12.3896 14.7848 11.8158 14.5471 11.3827 14.1141C11.1961 13.9285 3.25015 6.02438 2.60518 5.38281H23.3948ZM1.52344 19.5454V6.45557L8.10662 13.0041L1.52344 19.5454ZM2.60614 20.6172L9.18673 14.0784L10.3069 15.1927C11.0263 15.9121 11.9827 16.3082 13 16.3082C14.0173 16.3082 14.9737 15.9121 15.6917 15.1942L16.8133 14.0784L23.3939 20.6172H2.60614ZM24.4766 19.5454L17.8934 13.0041L24.4766 6.45557V19.5454Z",
    fill: "#4B1498"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b7f35081f2d08f33ea703782eb27e8f9.svg";
export { ForwardRef as ReactComponent };